import React, { useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { register } from '../../actions/auth';

const Register = ({ register, isAuthenticated, history }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    organization: '',
    email: '',
    phone: '',
    password: '',
    industry: ''
  });

  const {
    firstName,
    lastName,
    organization,
    email,
    phone,
    password,
    industry
  } = formData;

  const onChange = e =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = e => {
    e.preventDefault();
    register(formData, history);
  };

  if (isAuthenticated) {
    return <Redirect to='/' />;
  }

  return (
    <div className='container'>
      <div className='text-center'>
        <h1 className='x-large'>It is time to</h1>
        <h1>Action your sales</h1>
      </div>
      <div className='text-center'>
        {' '}
        <form className='form' onSubmit={e => onSubmit(e)}>
          <div className='form-group'>
            <input
              type='text'
              placeholder='First Name'
              name='firstName'
              value={firstName}
              onChange={e => onChange(e)}
            />
          </div>
          <div className='form-group'>
            <input
              type='text'
              placeholder='Last Name'
              name='lastName'
              value={lastName}
              onChange={e => onChange(e)}
            />
          </div>
          <div className='form-group'>
            <input
              type='text'
              placeholder='Organization'
              name='organization'
              value={organization}
              onChange={e => onChange(e)}
            />
          </div>
          <div className='form-group'>
            <input
              type='number'
              placeholder='Mobile Number'
              name='phone'
              value={phone}
              onChange={e => onChange(e)}
            />
          </div>
          <div className='form-group'>
            <input
              type='email'
              placeholder='Email'
              name='email'
              value={email}
              onChange={e => onChange(e)}
            />
          </div>
          <div className='form-group'>
            <input
              type='password'
              placeholder='Password'
              name='password'
              minLength='6'
              value={password}
              onChange={e => onChange(e)}
            />
          </div>
          <div className='form-group'>
            <input
              type='text'
              placeholder='Industry'
              name='industry'
              value={industry}
              onChange={e => onChange(e)}
            />
          </div>
          <input type='submit' className='btn btn-firm' value='Register' />
        </form>
        <p className='my-1'>
          Have an account already? <Link to='/'>Login</Link>
        </p>
      </div>
    </div>
  );
};

Register.propTypes = {
  register: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool
};

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated
});

export default connect(mapStateToProps, { register })(Register);



// WEBPACK FOOTER //
// ./src/components/auth/Register.js